import styled, { themeGet, css } from "@doar/shared/styled";
import { Media } from "@doar/components";

export const StyledMedia = styled(({ ...rest }) => <Media {...rest} />)`
    background-color: ${themeGet("colors.lilac")};
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    align-items: stretch;
    &:not(:first-of-type) {
        margin-top: -1px;
        border-top: 1px solid ${themeGet("colors.light")};
    }
    &.unread {
        background-color: #fff;
    }
    &.is-not-message-choose {
        background-color: #fff;
    }
    &:hover,
    &:focus {
        background-color: ${themeGet("colors.zircon")};
    }

    ${(props) =>
        props.theme.name === "dark" &&
        css`
            background-color: transparent;
            &:hover,
            &:focus {
                background-color: ${themeGet("colors.darkdarken2")};
            }
            + .media {
                border-top-color: ${themeGet("colors.gray900")};
            }
            &.unread {
                background-color: ${themeGet("colors.gray900")};
                &:hover,
                &:focus {
                    background-color: ${themeGet("colors.gray900")};
                }
            }
        `}
`;

export const StyledTop = styled.div`
    color: ${themeGet("colors.text3")};
    margin-bottom: 2px;
    align-items: center;
    justify-content: space-between;
    display: flex;
`;

export const StyledLeftSide = styled.label`
    width: 68px;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const StyledText = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 170px;
    font-size: 12px;
`;
export const StyledDesc = styled.p`
    width: 95%;

    &.is-description {
        margin: 0;
        white-space: nowrap;
        color: #001737;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 170px;
        margin-bottom: 0;
        font-size: 12px;
    }
`;
